import { get } from './common';
import { LaxhjalpenStudentListItem } from '../Types/laxhjalpenStudentList';

export async function getLaxhjalpenStudentList(unitId?: number): Promise<LaxhjalpenStudentListItem[]> {
	const query = unitId && unitId > 0 ? `?unitId=${unitId}` : '';
	return (await get<LaxhjalpenStudentListItem[]>(`api/laxhjalpenregistration/GetStudentList${query}`)) ?? [];
}
